<template >
  <!-- 弹框 -->
  <van-popup
    round
    position="bottom"
    v-model="dialogShow"
    style="height: '50%'; overflow: 'hidden'"
  >
    <van-picker
      show-toolbar
      title="标题"
      :columns="itemList"
      :value-key="bindInfo.bindLabel"
      @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange"
    >
      <template #title>
        <van-field
          class="picker_field"
          v-model="searchName"
          placeholder="请输入搜索内容"
          clearable
        />
      </template>
    </van-picker>
  </van-popup>
</template>

<script>
import request from "@/router/axios";
export default {
  name: "selectDrawer",
  data() {
    return {
      bindInfo: {
        bindKey: "id", // 绑定option取的字段， 必传
        bindLabel: "id",
        bindValue: "",
        dataUrl: "", // 数据地址, 必传
        bindId: "", // 绑定数据ID
        disabled: false, // 是否可用
        methods: "post", // 请求类型
        dataMethod: "data", // 请求传参方式data/params
        searchKey: "search", // 搜索关键词key
        initParam: {
          // 默认传参
        },
        innerKey: [],
        listName: "records", //返回的数据名字
        placeholder: "请选择",
      },
      bindItem: {},
      searchName: "",
      itemList: [],
      isLoading: false,
      loading: false,
      page: {
        currentPage: 1,
        pageSize: 100,
      },
      dialogShow: false,
      changeName: "change",
    };
  },
  watch: {
    //实时监听搜索输入内容
    searchName: function () {
      this.focusList();
    },
  },
  methods: {
    focusList() {
      this.itemList = [];
      if (this.searchName == "") {
        this.resetList();
      } else {
       
        this.queryList(this.searchName);
      }
    },

    resetList() {
      this.page.currentPage=1
      this.bindItem = undefined;
      this.searchName = "";
      this.itemList = [];
      this.queryList();
    },
    reset() {
      this.bindItem = undefined;
      this.searchName = "";
    },
    showDrawer(bindInfo, changeName) {
      this.dialogShow = true;
      this.bindInfo = {
        ...this.bindInfo,
        ...bindInfo,
      };
      this.changeName = changeName;
      this.queryList();
    },
    /**
     * 查询列表
     * @param {*} query 搜索字段
     */
    async queryList(query) {
      let params = {
        firstNum: (this.page.currentPage - 1) * this.page.pageSize,
        num: this.page.pageSize,
        current: this.page.currentPage,
        size: this.page.pageSize,
        custType: 2,
        ...this.bindInfo.initParam,
      };

      params[this.bindInfo.searchKey] = query ? query : undefined;
      this.isLoading = false;
      this.loading = true;
      let res = await this.requestItemList(params);
      let resArray = [];

      if (res.data.code == 200) {
        if (Array.isArray(res.data.data)) {
          resArray = res.data.data.map((item) => {
            let inner = "";
            // this.bindInfo.innerKey.map((el) => {
            //   inner += el.name + ":" + item[el.value];
            // });
            return {
              ...item,
              // inner: inner ? inner : item[this.bindInfo.bindLabel],
            };
          });
        } else if (Array.isArray(res.data.data[this.bindInfo.listName])) {
          resArray = res.data.data[this.bindInfo.listName].map((item) => {
            // let inner = "";
            // this.bindInfo.innerKey.map((el) => {
            //   inner += el.name + ":" + item[el.value];
            // });
            return {
              ...item,
              // inner: inner ? inner : item[this.bindInfo.bindLabel],
            };
          });
        } else {
          this.$message({
            type: "warning",
            message: "返回数据格式错误",
          });
          return false;
        }

        // if (resArray.length < this.page.pageSize||res.data.data.size==-1) {
        //   this.isLoading = true;
        // }

        // if (resArray.length > 0) {
        //   // 合并this.itemList和res.data.data
        //   let itemList = this.itemList.concat(resArray);

        //   this.itemList =
        //     this.bindInfo.innerKey.length > 0
        //       ? this.setHightLight(itemList, query)
        //       : itemList;
        // } else {
        //   this.itemList = [];
        // }
        this.itemList=resArray
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    // 获取流程详情
    requestItemList(data) {
      if (this.bindInfo.dataMethod == "data") {
        return request({
          url: `/api/${this.bindInfo.dataUrl}`,
          method: this.bindInfo.methods,
          data: data,
        });
      } else {
        return request({
          url: `/api/${this.bindInfo.dataUrl}`,
          method: this.bindInfo.methods,
          params: data,
        });
      }
    },
    // 设置高亮
    setHightLight(arr, keyword) {
      if (arr && arr.length > 0 && keyword) {
        arr = arr.filter((item) => {
          let reg = new RegExp(keyword, "g");
          let replaceString = `<span class='high'>${keyword.trim()}</span>`;

          if (item["inner"].match(reg)) {
            item["inner"] = item["inner"].replace(reg, replaceString);
            return item;
          }
        });

        return arr;
      }

      // 空返回原数组
      if (!keyword) {
        return arr;
      }
    },

    onConfirm(value, index) {
      this.dialogShow = false;
      this.$emit("handleChangeData", this.changeName, value);
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.reset();
      this.dialogShow = false;
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .ant-drawer-content {
  background-color: #f9f9f9;
}
/deep/ button.el-button.el-button--primary.is-round {
  padding: 0.25rem 0.7rem;
  font-size: 0.32rem;
}
/deep/ .el-radio__label {
  display: none;
}
/deep/ .el-radio {
  width: 0.5rem;
  height: 0.5rem;
}
/deep/ .el-message {
  min-width: 7rem !important;
}
.mobile-bottom-line-container {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 1.8rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  .bottom-button {
    font-size: 0.38rem;
    text-align: center;
    width: 2rem;
    i {
      font-size: 0.5rem;
      font-weight: 900;
    }
  }
  /deep/ .ant-drawer-body {
    .audit-popup-content {
      width: 100%;
      height: 100%;
      padding: 0.2rem 0.3rem;
      .opinion-title {
        font-size: 0.38rem;
        line-height: 0.8rem;
        height: 0.8rem;
        color: #333;
      }
      .submit-button-con {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        /* height: 1rem; */
        margin-top: 0.2rem;
      }
    }

    .mobile-audit-roll-back-container {
      background-color: #f9f9f9;
      width: 100%;
      height: 100%;
      .roll-back-title {
        width: 100%;
        text-align: center;
        font-weight: 600;
        color: #333;
        font-size: 0.45rem;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        background-color: #fff;
      }
      .roll-back-list {
        .option-one {
          .option-title {
            width: 100%;
            padding: 0.25rem 0.3rem;
            color: #999;
            font-size: 0.38rem;
          }
          .option-content {
            background-color: #fff;
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0.2rem 0.3rem;
            align-items: center;
            border-top: 0.5px solid #f2f2f2;
            border-bottom: 0.5px solid #f2f2f2;
            .content-left {
              font-size: 0.38rem;
              .roll-back-person {
                color: #333;
                span {
                  color: #409eff;
                }
              }
              .roll-back-time {
                color: #999;
                font-size: 0.38rem;
              }
            }
          }
        }
      }
      .comment-content {
        width: 100%;
        padding: 0.2rem 0.3rem 0.3rem;
        background-color: #fff;
        margin-top: 0.25rem;
        border-top: 0.5px solid #f2f2f2;
        border-bottom: 0.5px solid #f2f2f2;
        .comment-title {
          font-size: 0.38rem;
          color: #999;
          line-height: 0.75rem;
        }
        .el-textarea {
          font-size: 0.38rem;
          color: #333;
        }
      }
      .submit-button-con {
        width: 70%;
        margin-top: 0.25rem;
        text-align: center;
        margin: 0.25rem auto 0;
        .el-button {
          width: 100%;
        }
      }
    }
  }
}
/deep/ .picker_field {
  flex: 1;
}
</style>
